import type React from 'react';
import { Slider } from '@heroui/react';

const SCALE_STEPS = [0.5, 0.6, 0.7, 0.8, 0.9, 1.00, 1.1, 1.2, 1.3, 1.4, 1.5];

interface RosTextSliderProps {
  value: number;
  onChange: (value: number) => void;
  label?: string;
}

const RosTextSlider: React.FC<RosTextSliderProps> = ({
  value,
  onChange,
  label = 'Text size',
}) => {
  const currentIndex = SCALE_STEPS.findIndex((v) => v === value);

  return (
    <div className="flex w-full justify-between items-center">
      <label className="font-medium text-sm w-[100px]">
        {label}
      </label>
      <div className="flex justify-end relative w-full">
        <Slider
          color='danger'
          step={1}
          maxValue={SCALE_STEPS.length - 1}
          minValue={0}
          defaultValue={100}
          value={currentIndex === -1 ? 3 : currentIndex}

          onChange={(idx) => {
            if (typeof idx === 'number') onChange(SCALE_STEPS[idx]);
            else if (Array.isArray(idx)) onChange(SCALE_STEPS[idx[0]]);
          }}
          aria-label="transparency"
          classNames={{
            base: 'max-w-[140px] cursor-pointer gap-3',
            track: 'slider-border-width h-1',
            filler: 'bg-red-500'
          }}
          renderThumb={(props) => (
            <div
              {...props}
              className="group p-1 top-1/2 bg-red-500 shadow-medium rounded-full cursor-grab data-[dragging=true]:cursor-grabbing"
            >
              <span className="bg-red-500 shadow-small rounded-full w-2 h-2 block" />
            </div>
          )}
        />
      </div>
    </div>
  );
};

export default RosTextSlider;
